import React, {Component} from 'react'
import NumberFormat from 'react-number-format'

class NumberField extends Component {

	constructor(props) {
		super(props)
	}

	handleChange = v => {
		if(this.props.numeric) {
			v.value = parseInt(v.value)
		}
		else if(this.props.float) {
			v.value = parseFloat(v.value)
		}
		if (this.props.row) {
			this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`,v.value)
		} else {
			this.props.onChange(this.props.name, v.value)
		}
	}

	clear = () => {
		this.props.onChange(this.props.name, null)
	}
	
	render() {
		let decimals = 2
		if(this.props.coord) decimals = 6
		if(this.props.decimals) decimals = this.props.decimals
		return (
			<>
				<NumberFormat
					thousandSeparator={this.props.thousandSeparator}
					prefix={this.props.prefix}
					suffix={this.props.suffix}
					//onValueChange={(v) => { this.props.onChange(this.props.name, v.value) }}
					onValueChange={this.handleChange}
					onBlur={() => {
						this.props.onBlur(this.props.name, true)
					}}
					className="form__input"
					format={this.props.format}
					mask={this.props.mask}
					value={this.props.value}
					decimalScale={decimals}
					fixedDecimalScale={this.props.float ? true : false}
				/>
				{this.props.clearable ? (
					<div className="numberInput__close" onClick={() => this.clear()}>
						X
					</div>
				) : null}
			</>
		)
	}
}

export default NumberField
